import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import getExtPath from 'shared-utils/src/getExtPath';

const brpXS = createBreakpoint('xs');
const brpM = createBreakpoint('m');

export const mainCls = 'csa_header';
export default {
  [mainCls]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    padding: '0 8px',
    width: '100%',
    height: 60,
    background: '#FFF',
    borderBottom: '1px solid #d8dbdf',
    zIndex: 7,
    [brpXS]: {
      padding: '0 16px',
    },
    [brpM]: {
      padding: '0 32px',
    },
  },
  [`${mainCls}__logo`]: {
    position: 'absolute',
    top: 9,
    left: '50%',
    marginLeft: '-62px',
    width: 124,
    height: 42,
    '& img': {
      height: 42,
    }
  },
  [`${mainCls}__btn`]: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent!important',
    padding: 0,
    width: 44,
    height: 44,
    border: '0 none',
    [brpM]: {
      width: 'auto',
      overflow: 'visible',
      '&:hover': {
        [`& .${mainCls}__btn--txt`]: {
          '&::after': {
            opacity: '.9',
            transform: 'translateY(-9px)',
          },
        },
      },
    },
  },
  [`${mainCls}__btn--txt`]: {
    display: 'none',
    [brpM]: {
      display: 'block',
      position: 'relative',
      lineHeight: '44px',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        left: 0,
        width: '100%',
        height: 2,
        background: colors.secondary.rgba,
        opacity: 0,
        transition: 'opacity .3s, transform .3s',
      },
      '&.tras': {
        '&::after': {
          background: '#FFF',
        },
      },
    },
  },

  [`${mainCls}__btn--txt--hid`]: {
    opacity: 0,
  },
  [`${mainCls}__menu`]: {
    marginRight: 'auto',
  },
  [`${mainCls}__back--icon`]: {
    transform: 'rotate(90deg)',
  },
  [`${mainCls}__utils`]: {
    marginLeft: 'auto',
    width: 44,
    height: 44,
    [brpM]: {
      display: 'flex',
      alignItems: 'center',
      width: 'auto',
    },
  },
  [`${mainCls}__pub`]: {
    display: 'none',
    [brpM]: {
      display: 'flex',
    },
  },
  [`${mainCls}__my`]: {
    justifyContent: 'flex-end',
    [brpM]: {
      justifyContent: 'flex-start',
      width: 140,
      [`& .${mainCls}__btn--txt`]: {
        width: 109,
      },
      '&.auth': {
        width: 'auto',
        [`& .${mainCls}__btn--txt`]: {
          width: 'auto',
        },
      },
    }
  },
  [`${mainCls}__my--icon`]: {
    width: '23px!important',
    height: '28px!important',
    [brpM]: {
      width: '23px!important',
      height: '23px!important',
    },
  },
  [`${mainCls}__my--authusr`]: {
    display: 'block',
    width: 44,
    height: 44,
    background: `url(${getExtPath('common_images/header/avatar_mobile_loggato_bluestone.svg')}) right center no-repeat`,
    [brpM]: {
      marginTop: 8,
      width: 28,
      height: 28,
      backgroundImage: `url(${getExtPath('common_images/header/avatar_loggato_bluestone.svg')})`,
      backgroundSize: '28px 28px',
    },
  },  
  [`${mainCls}--sdw`]: {
    boxShadow: '0px 6px 10px -6px rgba(105, 118, 132, 0.5)',
  },
  [`${mainCls}--trs`]: {
    position: 'absolute',
    background: 'transparent',
    borderBottom: '1px solid transparent',
    [`& .${mainCls}__logo`]: {
      display: 'none',
    },
    [`& .${mainCls}__my--authusr`]: {
      backgroundImage: `url(${getExtPath('common_images/header/avatar_mobile_loggato.svg')})`,
      [brpM]: {
        backgroundImage: `url(${getExtPath('common_images/header/avatar_loggato.svg')})`,
      },
    },
  },
  [`${mainCls}--fix`]: {
    position: 'fixed',
    transform: 'translate(0, 0)',
    transition: 'transform .3s linear',
  },
  [`${mainCls}--hid`]: {
    position: 'fixed',
    transform: 'translate(0, -60px)',
    boxShadow: '0px 6px 10px -6px rgba(105, 118, 132, 0)',
  },
  [`${mainCls}--hiding`]: {
    transition: 'transform .3s linear',
  },
};
